<template>
  <div :class="{isShow:!isShowDanMu}" class="live-barrages">
    <v-barrage :initDanmu='initDanmu' :isPause="isPause" :arr='arr' :percent="100">
    </v-barrage>
  </div>
</template>

<script>
import VBarrage from "@/views/cloudClassCenter/components/common/VBarrage";

export default {
  name: "PlayBackBarrages",
  components: {
    VBarrage
  },
  props: {
    //用户发送的弹幕库
    liveBarrage: {},
    //视频当前播放时间
    playTimeupDate: {},
    //是否显示弹幕
    isShowDanMu: {},
    //初始化弹幕
    initDanmu: {}
  },
  data() {
    return {
      //弹幕库
      arr: [],
      // 弹幕是否暂停状态
      isPause: false,
      sendContent: null,
      isJs: false,
      direction: "default",
      //视频保存弹幕
      danmuku: [],
      //弹幕添加延迟函数
      addDanmuTO: null,
      //延迟函数ID数组
      setTimeoutId: [],
      //视频播放时间
      videoPlayTime: 0
    };
  },

  watch: {
    liveBarrage(newVal) {
      this.arr.push({
        content: newVal.say, // 弹幕内容
        direction: this.direction, // 方向  default | top
        isSelf: newVal.fromId == this.$store.state.userId ? true : false, // 是否是自己发的弹幕
        // style: {
        //   color: "red" // 弹幕颜色
        // },
        isJs: false // 是否解析html
      });
    },

    playTimeupDate(newVal) {
      if (newVal) {
        this.videoPlayTime = newVal;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.live-barrages {
  pointer-events: none;
  position: relative;
  width: 100%;
  height: 230px;
}

.isShow {
  opacity: 0;
}
</style>